import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { FileText, Smartphone, MessageSquare, Calendar } from 'lucide-react';
export function PricingSection() {
  return <div id="pricing" className="bg-cream w-full pb-24" data-id="element-38">
      <Section data-id="element-39">
        <div className="bg-white rounded-3xl shadow-xl shadow-navy/5 overflow-hidden border border-navy/5" data-id="element-40">
          <div className="p-8 md:p-12 grid md:grid-cols-2 gap-12" data-id="element-41">
            <div data-id="element-42">
              <h2 className="font-serif text-3xl md:text-4xl text-navy font-bold mb-6" data-id="element-43">
                Qué recibís (instantáneo)
              </h2>
              <div className="space-y-6" data-id="element-44">
                {[{
                icon: FileText,
                title: 'PDF Completo',
                desc: '“Kit 5 Minutos para Bajar la Ansiedad” con el protocolo explicado.'
              }, {
                icon: Smartphone,
                title: 'Tarjeta SOS 5x5',
                desc: 'Versión resumida para fondo de pantalla o impresión rápida.'
              }, {
                icon: MessageSquare,
                title: 'Lista de Frases de Control',
                desc: 'Opciones lógica, compasiva y confrontativa según lo que necesites.'
              }, {
                icon: Calendar,
                title: 'Tracker de 7 días',
                desc: 'Para generar el hábito y que tu cuerpo aprenda la secuencia.'
              }].map((item, i) => <div key={i} className="flex gap-4" data-id="element-45">
                    <div className="w-12 h-12 rounded-full bg-sage/10 flex items-center justify-center shrink-0 text-sage" data-id="element-46">
                      <item.icon className="w-6 h-6" data-id="element-47" />
                    </div>
                    <div data-id="element-48">
                      <h4 className="font-bold text-navy text-lg" data-id="element-49">
                        {item.title}
                      </h4>
                      <p className="text-navy/70 text-sm" data-id="element-50">{item.desc}</p>
                    </div>
                  </div>)}
              </div>
            </div>

            <div className="flex flex-col justify-center bg-navy/5 rounded-2xl p-8 text-center" data-id="element-51">
              <span className="text-navy/60 text-sm font-medium uppercase tracking-wider mb-2" data-id="element-52">
                Precio Único
              </span>
              <div className="flex items-center justify-center gap-1 mb-1" data-id="element-53">
                <span className="text-2xl font-serif text-navy/40 line-through" data-id="element-54">
                  $490
                </span>
              </div>
              <div className="flex items-center justify-center gap-2 mb-1" data-id="element-55">
                <span className="text-5xl font-serif font-bold text-navy" data-id="element-56">
                  $249
                </span>
                <span className="text-xl text-navy/60" data-id="element-57">UYU</span>
              </div>
              <span className="inline-block bg-terracotta/10 text-terracotta text-sm font-semibold px-3 py-1 rounded-full mb-2" data-id="element-58">
                49% OFF — Precio de lanzamiento
              </span>
              <p className="text-navy/60 text-sm mb-8" data-id="element-59">
                Pago seguro • Descarga inmediata
              </p>

              <Button fullWidth className="mb-4" href="https://alivionatural.site/cart/51377708466497:1" data-id="element-60">
                Quiero el Kit 5x5
              </Button>

              <p className="text-xs text-navy/50 max-w-xs mx-auto" data-id="element-61">
                Garantía de satisfacción. Si sentís que no te aporta valor, te
                devolvemos el dinero sin preguntas.
              </p>
            </div>
          </div>

          <div className="bg-navy p-8 text-center" data-id="element-62">
            <h3 className="font-serif text-2xl text-white mb-4" data-id="element-63">El Cierre</h3>
            <p className="text-cream/80 max-w-2xl mx-auto text-lg" data-id="element-64">
              No te voy a prometer que nunca más vas a sentir ansiedad. Te
              prometo algo mejor:
              <span className="text-terracotta font-bold" data-id="element-65">
                {' '}
                que cuando aparezca, no te agarre sin herramientas.
              </span>
            </p>
          </div>
        </div>
      </Section>
    </div>;
}